// Image Carousel
(function() {

    $A.on("load", function() {
        let availableCarousels = document.querySelectorAll('[data-whatsock-module="image-carousel"]');

        if (!("setCarousel" in $A)) {
            console.log('Carousel (Image) not set.');
        }
        else{
            console.log('Carousel (Image) Set w/ ', availableCarousels.length);
            render();
        }

        function formatNumber( num ){
            return new String(num).padStart(2, '0');
        }

        function render(){
            for (var i = availableCarousels.length - 1; i >= 0; i--) {
                let thisCarousel = availableCarousels[i];
                let carouselDC;
                let isActive = false;

                if(!thisCarousel.classList.contains('module-loaded')){
                    thisCarousel.classList.add('module-loaded');

                    let setCarouselOptions = {
                        container: ".image-carousel-"+availableCarousels[i].dataset.index,
                        mode: "gallery",
                        items: 1,
                        nav: 0,
                        lazyload: 1,
                        slideBy: "page",
                        controlsContainer: "#controls-"+availableCarousels[i].dataset.index,
                        prevButton: ".previous-"+availableCarousels[i].dataset.index,
                        nextButton: ".next-"+availableCarousels[i].dataset.index,
                        onInit: function(){
                            thisCarousel.ariaLabel = "Main Carousel";

                            console.log('thisCarousel', thisCarousel);

                            let allItems = thisCarousel.getElementsByClassName('tns-item');

                            for (var i = allItems.length - 1; i >= 0; i--) {
                                let aTagsInit = allItems[i].getElementsByTagName('a');

                                 for (var j = aTagsInit.length - 1; j >= 0; j--) {
                                    aTagsInit[j].tabIndex = -1;
                                };
                            };


                            let firstElem = thisCarousel.getElementsByClassName('tns-slide-active');
                            let curAtags = firstElem[0].getElementsByTagName('a');

                            for (var j = curAtags.length - 1; j >= 0; j--) {
                                curAtags[j].tabIndex = 0;
                            };
                        }
                    };

                    carouselDC = $A.setCarousel( setCarouselOptions );
                    isActive = true;
                }

                let localContainer = carouselDC.tns.getInfo().controlsContainer
                let localCountController = carouselDC.tns.getInfo().controlsContainer.querySelector('.count--current');
                let localTotalController = carouselDC.tns.getInfo().controlsContainer.querySelector('.count--total');

                if( carouselDC.tns.getInfo().controlsContainer.querySelector('.count--total') && carouselDC.tns.getInfo().controlsContainer.querySelector('.count--current') ){

                    carouselDC.tns.getInfo().controlsContainer.querySelector('.count--total').innerText = formatNumber( carouselDC.tns.getInfo().slideCount );

                    carouselDC.tns.getInfo().controlsContainer.querySelector('.count--current').innerText = formatNumber( carouselDC.tns.getInfo().displayIndex );
                }

                carouselDC.tns.events.on('indexChanged', function(){
                    let localCountController = carouselDC.tns.getInfo().controlsContainer.querySelector('.count--current');
                    let localTotalController = carouselDC.tns.getInfo().controlsContainer.querySelector('.count--total');

                    for (var i = carouselDC.tns.getInfo().slideItems.length - 1; i >= 0; i--) {
                        let aTags = carouselDC.tns.getInfo().slideItems[i].getElementsByTagName('a');

                        for (var j = aTags.length - 1; j >= 0; j--) {
                            aTags[j].tabIndex = -1;
                        };
                    };

                    let idx = carouselDC.tns.getInfo().index;
                    let curATags  = carouselDC.tns.getInfo().slideItems[idx].getElementsByTagName('a');


                    for (var k = curATags.length - 1; k >= 0; k--) {
                        curATags[k].tabIndex = 0;
                    };

                    if(carouselDC.tns.getInfo().controlsContainer.querySelector('.count--current')){
                        let percentage = (carouselDC.tns.getInfo().displayIndex/carouselDC.tns.getInfo().slideCount)*100;
                        let progressBar = thisCarousel.querySelector('.progress');

                        progressBar.style.width = percentage+"%";

                        carouselDC.tns.getInfo().controlsContainer.querySelector('.count--current').innerText = formatNumber( carouselDC.tns.getInfo().displayIndex );
                    }
                });
            };
        }
    });
})();